/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import {
  AuthProtocolGetInfoResponse,
  AuthProtocolLoginRequest,
  AuthProtocolLoginResponse,
  AuthProtocolLogoutRequest,
  AuthProtocolOktaLoginRequest,
  AuthProtocolOktaLoginResponse,
  AuthProtocolRefreshTokenRequest,
  AuthProtocolRefreshTokenResponse,
} from './data-contracts';
import { ContentType, HttpClient, RequestParams } from './http-client';

export class Auth<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>;

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http;
  }

  /**
   * No description
   *
   * @tags Auth
   * @name LoginCreate
   * @request POST:/auth/login
   */
  loginCreate = (data: AuthProtocolLoginRequest, params: RequestParams = {}) =>
    this.http.request<AuthProtocolLoginResponse, any>({
      path: `/auth/login`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Auth
   * @name LogoutCreate
   * @request POST:/auth/logout
   */
  logoutCreate = (data: AuthProtocolLogoutRequest, params: RequestParams = {}) =>
    this.http.request<void, any>({
      path: `/auth/logout`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags Auth
   * @name RefreshTokenCreate
   * @request POST:/auth/refresh_token
   */
  refreshTokenCreate = (data: AuthProtocolRefreshTokenRequest, params: RequestParams = {}) =>
    this.http.request<AuthProtocolRefreshTokenResponse, any>({
      path: `/auth/refresh_token`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Auth
   * @name InfoList
   * @request GET:/auth/info
   */
  infoList = (params: RequestParams = {}) =>
    this.http.request<AuthProtocolGetInfoResponse, any>({
      path: `/auth/info`,
      method: 'GET',
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Auth
   * @name LoginOktaCreate
   * @request POST:/auth/login/okta
   */
  loginOktaCreate = (data: AuthProtocolOktaLoginRequest, params: RequestParams = {}) =>
    this.http.request<AuthProtocolOktaLoginResponse, any>({
      path: `/auth/login/okta`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
}
